<template>
  <router-view />
</template>

<script>
import { useBrandingStore } from '@/stores/branding'
import { useAuthStore } from '@/stores/auth'

export default {
  name: 'App',
  created() {
    useBrandingStore().load()
    // Refresh permissions + plan on boot so grant/plan changes take effect
    // without re-login.
    const auth = useAuthStore()
    auth.loadPermissions()
    auth.loadPlan()
  },
}
</script>
